import { createBrowserRouter, Navigate } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import SessionLoader from "../components/SessionLoader";
import AuthLayout from "../layouts/AuthLayout";
import HomeLayout from "../layouts/HomeLayout";
import AudioPage from "../pages/AudioPage";
import ColorsPage from "../pages/ColorsPage";
import ExportPage from "../pages/ExportPage";
import ImagesPage from "../pages/ImagesPage";
import LoginPage from "../pages/LoginPage";
import PreviewPage from "../pages/PreviewPage";
import SettingsPage from "../pages/SettingsPage";
import SignupPage from "../pages/SignupPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import VerifyEmailPage from "../pages/VerifyEmailPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import { ROUTES } from "./routes";
import LandingPage from "../pages/LandingPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: "images", element: <ImagesPage /> },
      { path: "colours", element: <ColorsPage /> },
      { path: "audio", element: <AudioPage /> },
      { path: "preview", element: <PreviewPage /> },
      { path: "export", element: <ExportPage /> },
    ],
  },
  {
    path: "/app",
    element: <HomeLayout />,
    children: [
      { index: true, element: <Navigate to="/" replace /> },
    ],
  },
  {
    path: "/app/session/:sessionId",
    element: (
      <SessionLoader>
        <HomeLayout />
      </SessionLoader>
    ),
    children: [
      { index: true, element: <Navigate to="images" replace /> },
      { path: "images", element: <ImagesPage /> },
      { path: "colours", element: <ColorsPage /> },
      { path: "audio", element: <AudioPage /> },
      { path: "preview", element: <PreviewPage /> },
      { path: "export", element: <ExportPage /> },
    ],
  },
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <LoginPage />,
      },
      { path: "signup", element: <SignupPage /> },
      { path: "verify-email", element: <VerifyEmailPage /> },
      { path: "forgot-password", element: <ForgotPasswordPage /> },
      { path: "reset-password", element: <ResetPasswordPage /> },
    ],
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <HomeLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to={ROUTES.Settings()} replace /> },
      { path: "settings", element: <SettingsPage /> },
    ],
  },
]);
